import React from 'react';
const generalRules = ['Eye and ear protection is REQUIRED on all ranges at all times when shooting is in progress.', 'All shooters must sign in at the range before shooting.', 'No alcohol or drugs are permitted before or during shooting.', 'All firearms must be unloaded and cased when being transported to and from the range.', 'Cease fire immediately when anyone calls "CEASE FIRE."', 'Never handle firearms when anyone is downrange.', 'All shooters must shoot from the designated firing line.', 'Clean up your area when finished. Pick up all brass and dispose of targets properly.', 'Report any unsafe conditions or behavior to a Range Safety Officer.', 'No rapid fire unless specifically authorized for the event.', 'Guests must be accompanied by a member at all times.', 'Members are responsible for the actions of their guests.', 'No cross-firing between lanes or shooting positions.', 'All firearms malfunctions must be handled at the firing line with the muzzle pointed downrange.'];
export function GeneralRangeRules() {
  return <div className="w-full" style={{
    backgroundColor: '#f8f6f0'
  }} data-id="element-2850">
      <div className="max-w-4xl mx-auto px-4 md:px-8 pt-12" data-id="element-2851">
        <h2 className="text-2xl md:text-3xl font-bold uppercase mb-6" style={{
        fontFamily: 'Oswald, sans-serif',
        color: '#1e3d2f'
      }} data-id="element-2852">
          General Range Rules — All Ranges
        </h2>
        <div className="bg-white rounded-xl p-6 md:p-8 shadow-sm border" style={{
        borderColor: '#ede9e0'
      }} data-id="element-2853">
          <div className="space-y-4" data-id="element-2854">
            {generalRules.map((rule, index) => <div key={index} className="flex items-start gap-3" data-id="element-2855">
                <div className="w-6 h-6 rounded flex items-center justify-center flex-shrink-0 mt-0.5 text-xs font-bold" style={{
              backgroundColor: 'rgba(30,61,47,0.08)',
              color: '#1e3d2f',
              fontFamily: 'Oswald, sans-serif'
            }} data-id="element-2856">
                  {index + 1}
                </div>
                <p className="text-base text-gray-800" style={{
              fontFamily: 'Inter, sans-serif'
            }} data-id="element-2857">
                  {rule}
                </p>
              </div>)}
          </div>
        </div>
      </div>
    </div>;
}